
export default {
  props: {
    items: {
      type: Array,
      default: () => []
    }
  },
  mounted() {
    this.$emit("document-ready");
  },
  computed: {
    isSmallPrinter() {
      return this.$ls.get("printer-type", "md") == "sm";
    }
  }
};
